import { Grid } from "@mui/material";
import React from "react";
import useMedia from "use-media";
import { DetailInputsModalProps } from "../../../components/ModalExtractContent/ModalExtractContent";
import TitleAndDetailExtract from "../../../components/ModalExtractTitleAndDetail/ModalExtractTitleAndDetail";

interface ModalIcmsDetailsContentProps {
  petition: DetailInputsModalProps;
  xmlNotes: DetailInputsModalProps;
  refundValues: DetailInputsModalProps;
  color?: string;
  borderWidth?: number;
}

const ModalIcmsDetailsContent: React.FC<ModalIcmsDetailsContentProps> = ({
  petition,
  xmlNotes,
  refundValues,
  color,
  borderWidth = 0,
}) => {
  const isMobile = useMedia({ maxWidth: 901 });
  return (
    <Grid
      container
      sx={{
        border: borderWidth,
        borderStyle: "solid",
        borderColor: "shadesOfDark.ultraLight",
        borderRadius: "4px",
        flexWrap: "wrap",
      }}
      padding={2}
      paddingTop={1}
    >
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          display="flex"
          sx={{ justifyContent: "flex-start" }}
        >
          <TitleAndDetailExtract
            color={color}
            title={petition.title}
            detail={petition.value}
            textAlign={"left"}
            underline
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          display="flex"
          justifyContent={isMobile ? "flex-start" : "center"}
        >
          <TitleAndDetailExtract
            color={color}
            title={xmlNotes.title}
            detail={xmlNotes.value}
            textAlign={"left"}
            underline
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          display="flex"
          justifyContent={isMobile ? "flex-start" : "flex-end"}
        >
          <TitleAndDetailExtract
            color={color}
            title={refundValues.title}
            detail={refundValues.value}
            textAlign={isMobile ? "left" : "right"}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalIcmsDetailsContent;
